// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__K-otQ","overflowing":"ReadFullNote_overflowing__6Li7s"};